import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "板块选择", -1)
const _hoisted_3 = { class: "theme-toggle" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "首页", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "时间线", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--theme-secondary)"} }, "板块", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "sage串展示", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "海浪之家酒吧", -1)
const _hoisted_9 = {
  href: "http://gitea.islander.top",
  target: "_blank"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "岛民hub", -1)
const _hoisted_11 = {
  href: "https://github.com/A-islander/post-backup",
  target: "_blank"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "串备份地址", -1)
const _hoisted_13 = {
  href: "https://docs.apipost.cn/preview/b58077f3ebc9caeb/6a197cc600cf6f5c",
  target: "_blank"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "接口文档", -1)
const _hoisted_15 = {
  href: "https://www.nmbxd.com",
  target: "_blank"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "x岛（三酱岛）", -1)
const _hoisted_17 = {
  href: "https://www.naodong.fun",
  target: "_blank"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "脑洞", -1)
const _hoisted_19 = {
  href: "http://bog.ac",
  target: "_blank"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, "bog岛", -1)
const _hoisted_21 = {
  href: "https://huanleegao.com/t",
  target: "_blank"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, "欢乐恶狗岛", -1)
const _hoisted_23 = {
  href: "https://mszym.top/",
  target: "_blank"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, "钉幕石之音", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--theme-secondary)"} }, "板块选择", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, "首页", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, "时间线", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--theme-secondary)"} }, "板块", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, "sage串展示", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, "海浪之家酒吧", -1)
const _hoisted_31 = {
  href: "http://gitea.islander.top",
  target: "_blank"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, "岛民hub", -1)
const _hoisted_33 = {
  href: "https://github.com/A-islander/post-backup",
  target: "_blank"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "串备份地址", -1)
const _hoisted_35 = {
  href: "https://docs.apipost.cn/preview/b58077f3ebc9caeb/6a197cc600cf6f5c",
  target: "_blank"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, "接口文档", -1)
const _hoisted_37 = {
  href: "https://www.nmbxd.com",
  target: "_blank"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", null, "x岛（三酱岛）", -1)
const _hoisted_39 = {
  href: "https://www.naodong.fun",
  target: "_blank"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", null, "脑洞", -1)
const _hoisted_41 = {
  href: "http://bog.ac",
  target: "_blank"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, "bog岛", -1)
const _hoisted_43 = {
  href: "https://huanleegao.com/t",
  target: "_blank"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", null, "欢乐恶狗岛", -1)
const _hoisted_45 = {
  href: "https://mszym.top/",
  target: "_blank"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", null, "钉幕石之音", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_banner_artwork = _resolveComponent("banner-artwork")!
  const _component_house = _resolveComponent("house")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_guide = _resolveComponent("guide")!
  const _component_location = _resolveComponent("location")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_coffee_cup = _resolveComponent("coffee-cup")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_ctx.$route.meta.layout === 'fullscreen')
    ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_affix, { offset: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu, {
                    "default-active": $setup.activeIndex,
                    class: "el-menu-demo",
                    mode: "horizontal",
                    "active-text-color": "var(--theme-primary)",
                    "menu-trigger": "click"
                  }, {
                    default: _withCtx(() => [
                      (!$setup.mobileStatus)
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 0,
                            index: "plate",
                            style: {"color":"var(--theme-secondary)"},
                            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.mobileDrawerStatus = true))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_menu_item, {
                        index: "login",
                        style: {"color":"var(--theme-secondary)"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/login" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.cookieName), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_switch, {
                          modelValue: $setup.isDarkMode,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.isDarkMode) = $event)),
                          "inline-prompt": "",
                          "active-icon": $setup.Moon,
                          "inactive-icon": $setup.Sunny,
                          onChange: $setup.handleThemeChange
                        }, null, 8, ["modelValue", "active-icon", "inactive-icon", "onChange"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["default-active"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_container, {
            class: _normalizeClass($setup.bodyStyle)
          }, {
            default: _withCtx(() => [
              ($setup.mobileStatus)
                ? (_openBlock(), _createBlock(_component_el_aside, {
                    key: 0,
                    width: "200px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu, {
                        "default-active": "2",
                        class: "el-menu-vertical-demo",
                        collapse: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_banner_artwork, { banner: $setup.sidebarBanner }, null, 8, ["banner"]),
                          _createVNode(_component_router_link, { to: "/home" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_menu_item, {
                                index: "1",
                                style: {"color":"var(--theme-secondary)"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_house)
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_4
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, { to: '/plate/0/page/1' }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_menu_item, {
                                index: 'plate-' + 0,
                                style: {"color":"var(--theme-secondary)"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_guide)
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_5
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_sub_menu, { index: "2" }, {
                            title: _withCtx(() => [
                              _createVNode(_component_el_icon, { style: {"color":"var(--theme-secondary)"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_location)
                                ]),
                                _: 1
                              }),
                              _hoisted_6
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plateList, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createVNode(_component_router_link, {
                                    to: '/plate/' + item.id + '/page/1'
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_menu_item, {
                                        index: 'plate-' + item.id,
                                        style: {"color":"var(--theme-secondary)"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_guide)
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", null, _toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["index"])
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, { to: "/sageList" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_menu_item, {
                                index: "sageList",
                                style: {"color":"var(--theme-secondary)"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_location)
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_7
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, { to: "/bar" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_menu_item, {
                                index: "bar",
                                style: {"color":"var(--theme-secondary)"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_coffee_cup)
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_8
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("a", _hoisted_9, [
                            _createVNode(_component_el_menu_item, {
                              index: "3",
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_location)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_10
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("a", _hoisted_11, [
                            _createVNode(_component_el_menu_item, {
                              index: "3",
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_location)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("a", _hoisted_13, [
                            _createVNode(_component_el_menu_item, {
                              index: "4",
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_location)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("a", _hoisted_15, [
                            _createVNode(_component_el_menu_item, {
                              index: "8",
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_location)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_16
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("a", _hoisted_17, [
                            _createVNode(_component_el_menu_item, {
                              index: "5",
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_location)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_18
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("a", _hoisted_19, [
                            _createVNode(_component_el_menu_item, {
                              index: "6",
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_location)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_20
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("a", _hoisted_21, [
                            _createVNode(_component_el_menu_item, {
                              index: "7",
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_location)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_22
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("a", _hoisted_23, [
                            _createVNode(_component_el_menu_item, {
                              index: "7",
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_location)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_24
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_main, { style: {"padding":"0px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view, null, {
                    default: _withCtx(({ Component }) => [
                      (_openBlock(), _createBlock(_KeepAlive, { include: "plate,login" }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                      ], 1024))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode(_component_el_drawer, {
          modelValue: $setup.mobileDrawerStatus,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.mobileDrawerStatus) = $event)),
          size: "50%",
          direction: "ltr"
        }, {
          title: _withCtx(() => [
            _hoisted_25
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              "default-active": "2",
              class: "el-menu-mobile",
              collapse: false,
              style: {"border-right":"0"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_banner_artwork, { banner: $setup.sidebarBanner }, null, 8, ["banner"]),
                _createVNode(_component_router_link, {
                  to: "/home",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.mobileDrawerStatus = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      index: "1",
                      style: {"color":"var(--theme-secondary)"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_house)
                          ]),
                          _: 1
                        }),
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: '/plate/0/page/1',
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.mobileDrawerStatus = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      index: 'plate-' + 0,
                      style: {"color":"var(--theme-secondary)"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_guide)
                          ]),
                          _: 1
                        }),
                        _hoisted_27
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_sub_menu, { index: "2" }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, { style: {"color":"var(--theme-secondary)"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_location)
                      ]),
                      _: 1
                    }),
                    _hoisted_28
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plateList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createVNode(_component_router_link, {
                          to: '/plate/' + item.id + '/page/1',
                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.mobileDrawerStatus = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_menu_item, {
                              index: 'plate-' + item.id,
                              style: {"color":"var(--theme-secondary)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_guide)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", null, _toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["index"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/sageList",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.mobileDrawerStatus = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      index: "sageList",
                      style: {"color":"var(--theme-secondary)"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_location)
                          ]),
                          _: 1
                        }),
                        _hoisted_29
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/bar",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.mobileDrawerStatus = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      index: "bar",
                      style: {"color":"var(--theme-secondary)"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_coffee_cup)
                          ]),
                          _: 1
                        }),
                        _hoisted_30
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("a", _hoisted_31, [
                  _createVNode(_component_el_menu_item, {
                    index: "3",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _hoisted_32
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("a", _hoisted_33, [
                  _createVNode(_component_el_menu_item, {
                    index: "3",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _hoisted_34
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("a", _hoisted_35, [
                  _createVNode(_component_el_menu_item, {
                    index: "4",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _hoisted_36
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("a", _hoisted_37, [
                  _createVNode(_component_el_menu_item, {
                    index: "8",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _hoisted_38
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("a", _hoisted_39, [
                  _createVNode(_component_el_menu_item, {
                    index: "5",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _hoisted_40
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("a", _hoisted_41, [
                  _createVNode(_component_el_menu_item, {
                    index: "6",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _hoisted_42
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("a", _hoisted_43, [
                  _createVNode(_component_el_menu_item, {
                    index: "7",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _hoisted_44
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("a", _hoisted_45, [
                  _createVNode(_component_el_menu_item, {
                    index: "7",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_location)
                        ]),
                        _: 1
                      }),
                      _hoisted_46
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 64))
}